import { Component } from '@angular/core';

@Component({
  selector: 'app-average-pensionable-earnings-esps-info',
  templateUrl: './average-pensionable-earnings-esps-info.component.html',
  styleUrls: ['./average-pensionable-earnings-esps-info.component.scss']
})
export class AveragePensionableEarningsEspsInfoComponent {

}
